export default __webpack_public_path__ + "static/media/AnimalPage2.86d84253.txt";